import { useCallback, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllActiveInterviews } from "../../application/services/studentDashboard";
import { setUpcomingInterviews, appendUpcomingInterviews } from "../../store/studentPageReducer";

const useActiveInterviews = () => {
  const dispatch = useDispatch();
  const { upcomingInterviews } = useSelector((state) => state.studentpage);
  const { user } = useSelector((state) => state.login.student);
  const email = user?.email || "";

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false);

  const fetchActiveInterviews = useCallback(
    async (pageNum = 1, append = false) => {
      if (loadingRef.current || !email) {
        return;
      }
      
      loadingRef.current = true;
      setLoading(true);

      try {
        const response = await getAllActiveInterviews(email, pageNum, 6);
        
        const responseData = response?.data?.data || response?.data || [];
        const pagination = response?.data?.pagination || response?.pagination || {};
        const currentPage = pagination.page || pageNum;
        const limit = pagination.limit || 6;
        const total = pagination.total || 0;
        
        if (append) {
          dispatch(appendUpcomingInterviews(responseData));
        } else {
          dispatch(setUpcomingInterviews(responseData));
        }

        const totalPages = Math.ceil(total / limit);
        const hasMorePages = currentPage < totalPages;
        
        setHasMore(hasMorePages);
      } catch (error) {
        console.error("Error fetching active interviews:", error);
        setHasMore(false);
      } finally {
        loadingRef.current = false;
        setLoading(false);
      }
    },
    [dispatch, email]
  );

  const loadMore = useCallback(() => {
    if (hasMore && !loadingRef.current) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchActiveInterviews(nextPage, true);
    }
  }, [hasMore, page, fetchActiveInterviews]);

  return { 
    upcomingInterviews, 
    loadMore, 
    hasMore, 
    loading, 
    fetchActiveInterviews 
  };
};

export default useActiveInterviews;

